interface ResolvePackageCurrencyParams {
  selectedCurrency: General.Currency;
  lockedCurrency?: General.Currency;
  isEnterprise: boolean;
  currenciesOptions: General.Currency[];
}

export const resolvePackageCurrency = ({
  selectedCurrency,
  lockedCurrency,
  isEnterprise,
  currenciesOptions,
}: ResolvePackageCurrencyParams): General.Currency => {
  if (isEnterprise) {
    return currenciesOptions.includes(selectedCurrency)
      ? selectedCurrency
      : currenciesOptions[0] ?? selectedCurrency;
  }

  return lockedCurrency ?? selectedCurrency;
};

export const isPackageCurrencyLocked = (
  lockedCurrency: General.Currency | undefined,
  isEnterprise: boolean,
) => !isEnterprise && !!lockedCurrency;
